import React from "react";
import ChartGenerator from "../PieChartGenerator/ChartGenerator";

const BoardChart = ( props ) => {
    return (
        <div className="p-4" style={{ maxWidth: "1400px" }}>

            { props.board?.chart && props.board?.chart !== "" &&
                <ChartGenerator chartID={props.board?.chart} />
            }

        </div>
    );
}

export default BoardChart;